module.exports = __webpack_public_path__ + "img/rank-top-bg.4e69272d.png";